import { useSelector } from "hooks/useSelector"
import { find } from "lodash"
import { useCallback } from "react"
import { getEmpresaActivaConfigCuentasContables } from "../../User/redux/selectors/userSelectors"

// TODO: CUANDO SE CAMBIE LA CONFIGURACION DE REDUX A REACT QUERY SE PODRA ELIMINAR ESTE HOOK, AHORA MISMO ES LA MANERA DE DEVOLVER LAS CUENTAS CONTABLES POR DEFECTO QUE VIENEN POR /api/Empresa/from-resources/{nif}
const useCuentasContables = () => {
  const cuentasContablesPorDefecto = useSelector(
    getEmpresaActivaConfigCuentasContables
  )

  const getCuentaContablePorDefecto = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (CuentaContableCategoria: $TSMigrationFixMe) => {
      return find(
        cuentasContablesPorDefecto,
        ({ categoria }) => categoria === CuentaContableCategoria
      )?.cuentaContableId
    },
    [cuentasContablesPorDefecto]
  )

  return {
    getCuentaContablePorDefecto,
  }
}

export default useCuentasContables
